import { useQuery, type QueryHookOptions } from "@apollo/client"
import tenantInvitationQuery from "@/v2-backoffice-client/tenant/invitation/tenant.invitation.query.gql"
import type {
  TenantInvitationQuery,
  TenantInvitationQueryVariables,
} from "@/v2-backoffice-client/tenant/invitation/__types__/tenant.invitation.query"

export function useTenantInvitationQuery(
  options: QueryHookOptions<
    TenantInvitationQuery,
    TenantInvitationQueryVariables
  >,
) {
  return useQuery<TenantInvitationQuery, TenantInvitationQueryVariables>(
    tenantInvitationQuery,
    options,
  )
}
